// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3tVXO","addWidgetButton":"Header_addWidgetButton__o-2gw","dashboardTabs":"Header_dashboardTabs__3EIDm","active":"Header_active__1zbGI"};